export default __webpack_public_path__ + "static/media/Linkedim Learning Network+ prep4 making TCP-IP Work.58bfa46c.webp";